export default __webpack_public_path__ + "static/media/dreamfest (12).f20ac22d.jpg";